module.exports = __webpack_public_path__ + "static/media/account.4f5933f4.svg";